let env = {};

env.baseURL = 'https://api.checklist.it4d.com.br/api/v1/';
env.normalURL = 'https://api.checklist.it4d.com.br/';
env.mode = 'production';

export default env
